// const Buffer = require('buffer/').Buffer;
import {Buffer} from 'buffer/';

export default class Base64Encoder {
  encode(plaintext) {
    return Buffer.from(plaintext, 'binary').toString('base64');
  };

  decode(encoded) {
    return Buffer.from(encoded, 'base64').toString();
  };
}
